/**
 * Canonical 24×24 geometry for the playback audio-track icons.
 *
 * The audience artwork is inset to the same optical box as the rest of the
 * app's filled icon family. The clean-audio waveform uses rounded filled bars
 * equivalent to the supplied stroked SVG, so both glyphs share one rendering
 * language across native and web.
 */
export const AUDIENCE_ICON_PATHS = [
  "M.221 16.268a15.064 15.064 0 0 0 1.789 1.9C2.008 18.111 2 18.057 2 18a5.029 5.029 0 0 1 3.233-4.678 1 1 0 0 0 .175-1.784A2.968 2.968 0 0 1 4 9a2.988 2.988 0 0 1 5.022-2.2 5.951 5.951 0 0 1 2.022-.715 4.994 4.994 0 1 0-7.913 6.085 7.07 7.07 0 0 0-2.91 4.098zM23.779 16.268a7.07 7.07 0 0 0-2.91-4.1 4.994 4.994 0 1 0-7.913-6.086 5.949 5.949 0 0 1 2.022.715 2.993 2.993 0 1 1 3.614 4.74 1 1 0 0 0 .175 1.784A5.029 5.029 0 0 1 22 18c0 .057-.008.111-.01.167a15.065 15.065 0 0 0 1.789-1.899z",
  "M18.954 20.284a7.051 7.051 0 0 0-3.085-5.114A4.956 4.956 0 0 0 17 12a5 5 0 1 0-8.869 3.17 7.051 7.051 0 0 0-3.085 5.114 14.923 14.923 0 0 0 1.968.849C7.012 21.088 7 21.046 7 21a5.031 5.031 0 0 1 3.233-4.678 1 1 0 0 0 .175-1.785A2.964 2.964 0 0 1 9 12a3 3 0 1 1 6 0 2.964 2.964 0 0 1-1.408 2.537 1 1 0 0 0 .175 1.785A5.031 5.031 0 0 1 17 21c0 .046-.012.088-.013.133a14.919 14.919 0 0 0 1.967-.849z"
] as const;

export const AUDIENCE_ICON_TRANSFORM = "translate(1 1) scale(0.9166667)";

export const CLEAN_AUDIO_ICON_BARS = [
  { x: 1.1, y: 9.1, width: 1.8, height: 4.8 },
  { x: 5.1, y: 5.1, width: 1.8, height: 12.8 },
  { x: 9.1, y: 2.1, width: 1.8, height: 19.8 },
  { x: 13.1, y: 7.1, width: 1.8, height: 8.8 },
  { x: 17.1, y: 4.1, width: 1.8, height: 14.8 },
  { x: 21.1, y: 9.1, width: 1.8, height: 4.8 }
] as const;

export const CLEAN_AUDIO_ICON_BAR_RADIUS = 0.9;

/** Audio settings — normalized from the supplied Lucide headphones glyph. */
export const HEADPHONES_ICON_PATH =
  "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3";

export const HEADPHONES_ICON_STROKE_WIDTH = 1.8;
